import RegistrationForm from '../components/competitor/registrationForm.vue';
import PublicRegistrationForm from '../components/publicdomain/registrationForm.vue';
import dotresultInputForm from "../components/organisation/dotresultInputForm";
import dotresultResults from "../components/organisation/dotresultResults";
import registrationCheck from "../components/organisation/registrationCheck";
import dotCash from "../components/organisation/dotCash";

window.Vue.component('RegistrationForm', RegistrationForm);
window.Vue.component('PublicRegistrationForm', PublicRegistrationForm);
window.Vue.component('organisationDotresultInputForm', dotresultInputForm);
window.Vue.component('organisationDotresultResults', dotresultResults);
window.Vue.component('registrationCheck', registrationCheck);
window.Vue.component('dotCash', dotCash);

// Dynamic loading (breaks)
// window.Vue.component('RegistrationForm', import('../components/competitor/registrationForm.vue'));
// window.Vue.component('PublicRegistrationForm', import('../components/publicdomain/registrationForm.vue'));
